/* loaded by smart-asset */
export default require("./stop~lbXSmHgG.png")